import React, { Dispatch, SetStateAction, useCallback } from 'react'
import { SwapFreeOptionDto } from 'api/Clients/Types/SwapFreeOptionDto'
import { FilterType } from 'components/Filter'
import { SelectFiltersFacade } from 'components/Filter/ClientFields/SelectFiltersFacade'
import { getSwapFreeOptionsFields } from 'components/Filter/getSwapFreeOptionsFields'
import { useGridState } from 'features/DataGrid'
import { GridStateStatus } from 'features/DataGrid/hooks/useGridStatusState'
import { CompositeFilterDescriptor } from 'store/grid'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { buildQuery } from 'utils/QueryHelpers'
import { TableStateContextData } from 'utils/TableStateContext'

interface SwapFreeOptionsQuery {
  getQuery: (filter?: CompositeFilterDescriptor) => string | null
}

export const useSwapFreeOptionsBuildQuery = (): SwapFreeOptionsQuery => {
  const { gridState } = useGridState()

  const getQuery = useCallback(
    (filter?: CompositeFilterDescriptor) => {
      const gridFilter = filter ?? gridState.filter
      return buildQuery(gridFilter) ?? null
    },
    [gridState.filter] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return { getQuery }
}

interface SwapFreeOptionsPageProps {
  gridStatusState: GridStateStatus
  onChange(swapFreeOptions: SwapFreeOptionDto[]): void
  tableData: TableStateContextData
  setTableData: Dispatch<SetStateAction<TableStateContextData>>
}

export const SwapFreeOptionsTableFilter: React.FC<SwapFreeOptionsPageProps> = (props) => {
  const { tableData, setTableData } = props
  const { gridStatusState, gridStatusActions } = props.gridStatusState
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const { gridState, gridActions } = useGridState()

  const { getQuery } = useSwapFreeOptionsBuildQuery()

  const filterFetch = useCallback(
    async (params?: { query?: string | null }): Promise<void> => {
      const searchQuery = params?.query !== undefined ? params.query : getQuery()
      const pageIndex = 1
      const pageSize = gridState.pageSize ?? 10
      const take = gridState.take ?? 10
      const skip = 0

      const response = await tradingAccountsApiClient.getSwapFreeOptions({
        search: searchQuery,
        pageIndex,
        pageSize,
      })
      const total = response.totalResults

      if (response?.items) {
        props.onChange((response.items || []).map((x) => Object.assign({ selected: false }, x)))
      }

      gridActions.setGridFilters({
        take,
        skip,
        total,
        pageIndex,
      })
      setTableData({ ...tableData, meta: response })
    },
    [getQuery, gridActions, gridState.pageSize, gridState.sort, gridState.take] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return (
    <>
      <div className='records-clients'>
        <SelectFiltersFacade
          gridState={gridState}
          gridStatusActions={gridStatusActions}
          gridStatusState={gridStatusState}
          setGridFilters={gridActions.setGridFilters}
          filterFetch={filterFetch}
          filterType={FilterType.SwapFreeOptions}
          filterFields={getSwapFreeOptionsFields()}
          containerClassName='records-clients__filter'
          getQuery={getQuery}
        />
      </div>
    </>
  )
}
